export {InMemoryCache} from './inMemory';
export {MapCache} from './mapCache';
export type {Cache} from './types';
